import React from 'react';
import { ChatUser } from './ChatUser';

const INTEGRATION_CONFIG = {
  teams: {
    header: 'Teams',
    recordingKey: 'teamsRecordingEnabled',
  },
  delegate: {
    header: 'Integration',
    recordingKey: 'delegateRecordingEnabled',
  },
};

class ChatUserList extends React.Component {
  render() {
    const {
      integration,
      userList,
      hasExternalIntegration,
      userErrorMessage,
      onUserSelectionChanged,
      onUserSearchTextChanged,
      skipToken,
      onLoadMore,
    } = this.props;

    const nextPageOfUsersLink =
      skipToken != null ? (
        <div className="divTableRow">
          <div className="divTableCell column1"></div>
          <div className="divTableCell column2 loadMoreContainer">
            <button onClick={onLoadMore}>Load More</button>
          </div>
          <div className="divTableCell column3"></div>
        </div>
      ) : null;

    const { header, recordingKey } = INTEGRATION_CONFIG[integration];

    // Filter out users already provisioned in the other integration
    // Only if externalIntegration is ON
    let filteredUserList = userList;
    if (hasExternalIntegration) {
      if (integration === 'teams') {
        filteredUserList = userList.filter(user => !user.delegateRecordingEnabled);
      } else if (integration === 'delegate') {
        filteredUserList = userList.filter(user => !user.teamsRecordingEnabled);
      }
    }

    // For delegate integration, only one user can be selected at a time
    // Find if any user is currently selected in delegate list
    const selectedDelegateUserId =
      integration === 'delegate' && filteredUserList
        ? filteredUserList.find(user => user[recordingKey])?.id
        : null;

    const users =
      filteredUserList != null
        ? filteredUserList.map(user => {
            // Disable other users if one is already selected in delegate list
            const isDisabled =
              integration === 'delegate' &&
              selectedDelegateUserId != null &&
              user.id !== selectedDelegateUserId;

            return (
              <ChatUser
                key={`${integration}-${user.id}`}
                user={{ ...user, recordingEnabled: user[recordingKey] }}
                disabled={isDisabled}
                onValueChanged={(userId, isChecked) =>
                  onUserSelectionChanged(userId, isChecked, integration)
                }
              />
            );
          })
        : '';

    const infoMessages = [];
    if (integration === 'delegate') {
      infoMessages.push('* Only one integration user can be selected at a time.');
    }
    if (hasExternalIntegration) {
      infoMessages.push('* A user can only be selected in one table at a time.');
    }

    return (
      <div className="display-users">
        <h3 className="header">{header} Users</h3>
        {infoMessages.length > 0 && (
          <div className="info-messages">
            {infoMessages.map((message, index) => (
              <p key={index} className="info-text">
                {message}
              </p>
            ))}
          </div>
        )}
        <div>
          <div className="ui aligned container start mt-8">
            <div className="divTable">
              <div className="divTableRow">
                <div className="divTableHead column1">
                  Enable Recording
                  <br />
                </div>
                <div className="divTableHead column2">User Name</div>
                <div className="divTableHead settings-column">
                  <div className="fields">
                    <input
                      type="text"
                      placeholder="Search..."
                      onKeyDown={event => {
                        if (event.key === 'Enter') {
                          onUserSearchTextChanged(event);
                        }
                      }}
                      className={'displayInline'}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className={`usertable${integration === 'delegate' ? ' usertable-delegate' : ''}`}>
              <div className="divTable">
                {users}
                {nextPageOfUsersLink}
              </div>
            </div>
            <label id="errorMessageLabel" className="errorText">
              {userErrorMessage}
            </label>
          </div>
        </div>
      </div>
    );
  }
}

export { ChatUserList };
